import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SowChangeVerifyTaskAttemptSchema = z.discriminatedUnion("attemptType", [
  z.object({
    type: z.literal(TaskType.SOW_CHANGE_VERIFY),
    attemptType: z.literal("VERIFIED"),
  }),
  z.object({
    type: z.literal(TaskType.SOW_CHANGE_VERIFY),
    attemptType: z.literal("VERIFIED_MANUALLY"),
    reason: z.string().trim().min(1),
  }),
]);
